import { useMemo } from "react";

import { useGetSavedJobFiltersQuery } from "@js/apps/jobs/api";

export const useSavedSearches = () => {
  const { data: savedFilters = [], isLoading } = useGetSavedJobFiltersQuery();

  const savedFiltersSkillsIds = useMemo(() => {
    return [
      ...new Set(
        savedFilters
          .filter((filter) => !!filter?.filters?.skills)
          .map((filter) => {
            return (filter.filters.skills as string)
              .split(",")
              .map((skillString: string) => Number(skillString));
          })
          .flat(),
      ),
    ];
  }, [savedFilters]);
  return {
    savedFilters,
    savedFiltersSkillsIds,
    isLoading,
  };
};
